// Typelizer digest 278c37d6ddd1af4302e2683b0c3c9fb5
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** GET /rails/active_storage/representations/redirect/:signed_blob_id/:variation_key/*filename */
  show: (
    params: { signedBlobId: string | number; variationKey: string | number; filename: string | number },
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/rails/active_storage/representations/redirect/:signed_blob_id/:variation_key/*filename', params, options),
    method: 'get',
  }),
}
